/** True when the API indicates the Firebase user is not yet in Datastore. */
export function isUnregisteredError(message: string): boolean {
  return message.includes('User not registered') || message.includes('Not a member');
}
